import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询CopyMonth设置
export function queryPillCopyMonthSetting(requestBody) {
  return request({
    url: URL.act.pillReport.queryPillCopyMonthSettingUrl,
    method: 'post',
    data: requestBody
  })
}

// 保存CopyMonth设置
export function savePillCopyMonthSetting(requestBody) {
  return request({
    url: URL.act.pillReport.savePillCopyMonthSettingUrl,
    method: 'post',
    data: requestBody
  })
}

// 查询财务/HR数据设置
export function queryPillDataTypeSetting(requestBody) {
  return request({
    url: URL.act.pillReport.queryPillDataTypeSettingUrl,
    method: 'post',
    data: requestBody
  })
}

// 保存财务/HR数据设置
export function savePillDataTypeSetting(requestBody) {
  return request({
    url: URL.act.pillReport.savePillDataTypeSettingUrl,
    method: 'post',
    data: requestBody
  })
}

// 获取copyMonth、copyDate列表信息
export function loadSearchConditions(requestBody) {
  return request({
    url: URL.act.pillReport.loadSearchConditionsUrl,
    method: 'post',
    data: requestBody
  })
}

// 导出Accrue Report(Monthly)
export function exportAccrueReportMonthly(requestBody) {
  return request({
    url: URL.act.pillReport.exportAccrueReportMonthlyUrl,
    method: 'post',
    data: requestBody
  })
}

// 导出Accrue Report(Weekly)
export function exportAccrueReportWeekly(requestBody) {
  return request({
    url: URL.act.pillReport.exportAccrueReportWeeklyUrl,
    method: 'post',
    data: requestBody
  })
}

// 导出HR Real GP Report
export function exportHrRealGPReport(requestBody) {
  return request({
    url: URL.act.pillReport.exportHrRealGPReportUrl,
    method: 'post',
    data: requestBody
  })
}

// 销账数据导出
export function exportActualAmount(requestBody) {
  return request({
    url: URL.act.pillReport.exportActualAmountUrl,
    method: 'post',
    data: requestBody
  })
}

// 发票数据导出
export function exportInvoice(requestBody) {
  return request({
    url: URL.act.pillReport.exportInvoiceUrl,
    method: 'post',
    data: requestBody
  })
}

// 海外账单数据导出
export function exportBilling(requestBody) {
  return request({
    url: URL.act.pillReport.exportBillingUrl,
    method: 'post',
    data: requestBody
  })
}

// 海外账单数据导出：CL
export function exportBillingCL(requestBody) {
  return request({
    url: URL.act.pillReport.exportBillingCLUrl,
    method: 'post',
    data: requestBody
  })
}

// 生成Accrue Report数据
export function generatePillReportData(requestBody) {
  return request({
    url: URL.act.pillReport.generatePillReportDataUrl,
    method: 'post',
    data: requestBody
  })
}

// 获取copyMonth、copyDate列表信息：Report数据
export function loadSearchConditions2Report(requestBody) {
  return request({
    url: URL.act.pillReport.loadSearchConditions2ReportUrl,
    method: 'post',
    data: requestBody
  })
}
